import React from 'react';
import './Sub-services.css';
import citofonia from './assets/Citofonia.png';

const Citofonia = () => {
  return (
    <div className="containerSer">
      <h2>Instalación de sistemas de citofonía digital Y videoporteros</h2>
      <p>
        Los sistemas de portería inteligente/videoporteros combinan audio, video
        en tiempo real y control de acceso remoto, permitiéndote identificar y
        autorizar la entrada de visitantes desde una pantalla o tu teléfono
        móvil. Son soluciones ideales para viviendas unifamiliares, edificios,
        oficinas o negocios que buscan elevar sus estándares de seguridad y
        comodidad.
      </p>
      <img
        src={citofonia}
        alt="Imagen de mantenimiento de un citofono"
      />
      <p>
        Ofrecemos el suministro e instalación de sistemas de video porteros,
        portería inteligente y control de acceso para viviendas, edificios y
        negocios; este servicio te incluye: asesoría personalizada para
        seleccionar el sistema adecuado, suministro de dispositivos según tus
        necesidades, instalación del sistema, configuración de red y
        comunicación para acceso con smartphones además capacitación de manejo.
      </p>
      <h3>Beneficios clave:</h3>
      <ul>
        <li>Mayor seguridad al verificar quién solicita acceso.</li>
        <li>
          Control desde el celular o dispositivos internos, incluso a distancia.
        </li>
        <li>Control ante posibles intrusos o situaciones sospechosas.</li>
        <li>Valorización de tu propiedad al incorporar nuevas tecnologías.</li>
        <li>Tranquilidad al contar con asesoría confiable y experta.</li>
      </ul>
    </div>
  );
};

export default Citofonia;
